const PICKER_SELECTOR = 'variant-picker[data-variant-style="quantity_cards"]';

/** @type {Map<string, Map<string, {colors: string[], sizes: string[]}>>} */
const selections = new Map();

function pickerKey(picker) {
  return `${picker.dataset.sectionId || ''}:${picker.dataset.blockId || ''}:${picker.dataset.productId || ''}`;
}

function getProductForm(picker) {
  const scope = picker.closest('.product-details, .product-information, .shopify-section') || document;
  return scope.querySelector('form[action*="/cart/add"]');
}

function getSelectedItem(picker) {
  return Array.from(picker.querySelectorAll('[data-quantity-card-item]')).find((item) =>
    item.querySelector('.quantity-card > input:checked')
  );
}

function featureEnabled(picker, type) {
  return type === 'color'
    ? picker.dataset.enableQuantityColors === 'true'
    : picker.dataset.enableQuantitySizes === 'true';
}

function getDefaultValue(picker, item, type) {
  const sourceSelector = type === 'color' ? '[data-bundle-source-color]:checked' : '[data-bundle-source-size]:checked';
  const choiceSelector = type === 'color' ? '[data-color-choice]:not(:disabled)' : '[data-size-choice]:not(:disabled)';
  const valueKey = type === 'color' ? 'colorValue' : 'sizeValue';
  return picker.querySelector(sourceSelector)?.value || item?.querySelector(choiceSelector)?.dataset[valueKey] || '';
}

function normalizeValues(values, count, defaultValue, enabled) {
  if (!enabled) return [];
  while (values.length < count) values.push(defaultValue);
  values.length = count;
  return values;
}

function getItemSelections(picker, item) {
  const key = pickerKey(picker);
  const quantityValue = item.dataset.quantityValue || '';
  const unitCount = Math.max(1, Number.parseInt(item.dataset.unitCount || '1', 10));
  if (!selections.has(key)) selections.set(key, new Map());
  const pickerSelections = selections.get(key);
  const stored = pickerSelections.get(quantityValue) || { colors: [], sizes: [] };

  stored.colors = normalizeValues(stored.colors, unitCount, getDefaultValue(picker, item, 'color'), featureEnabled(picker, 'color'));
  stored.sizes = normalizeValues(stored.sizes, unitCount, getDefaultValue(picker, item, 'size'), featureEnabled(picker, 'size'));
  pickerSelections.set(quantityValue, stored);

  return stored;
}

function syncFormProperties(picker, selected) {
  const form = getProductForm(picker);
  if (!form) return;

  form.querySelectorAll('[data-quantity-card-property]').forEach((input) => input.remove());

  const appendProperties = (values, propertyName) => {
    values.forEach((value, index) => {
      if (!value) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${propertyName} ${index + 1}]`;
      input.value = value;
      input.dataset.quantityCardProperty = 'true';
      form.appendChild(input);
    });
  };

  appendProperties(selected.colors, picker.dataset.colorPropertyName || 'Cor');
  appendProperties(selected.sizes, picker.dataset.sizePropertyName || 'Tamanho');
}

function renderChoiceGroup(row, selector, valueKey, selectedValue) {
  row.querySelectorAll(selector).forEach((button) => {
    const isSelected = button.dataset[valueKey] === selectedValue;
    button.classList.toggle('is-selected', isSelected);
    button.setAttribute('aria-pressed', String(isSelected));
  });
}

function renderPicker(picker) {
  const selectedItem = getSelectedItem(picker);
  if (!selectedItem) return;

  const selected = getItemSelections(picker, selectedItem);
  const colorSummary = selectedItem.querySelector('[data-color-selection-summary]');
  const sizeSummary = selectedItem.querySelector('[data-size-selection-summary]');

  if (colorSummary) colorSummary.textContent = selected.colors.filter(Boolean).join(' + ');
  if (sizeSummary) sizeSummary.textContent = selected.sizes.filter(Boolean).join(' + ');

  selectedItem.querySelectorAll('[data-unit-index]').forEach((row) => {
    const index = Math.max(0, Number.parseInt(row.dataset.unitIndex || '1', 10) - 1);
    renderChoiceGroup(row, '[data-color-choice]', 'colorValue', selected.colors[index] || '');
    renderChoiceGroup(row, '[data-size-choice]', 'sizeValue', selected.sizes[index] || '');
  });

  syncFormProperties(picker, selected);
}

function renderAll() {
  document.querySelectorAll(PICKER_SELECTOR).forEach(renderPicker);
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const button = target?.closest('[data-color-choice], [data-size-choice]');
  if (!button || button.disabled) return;

  const picker = button.closest(PICKER_SELECTOR);
  const item = button.closest('[data-quantity-card-item]');
  const row = button.closest('[data-unit-index]');
  if (!picker || !item || !row) return;

  event.preventDefault();

  const type = button.hasAttribute('data-size-choice') ? 'size' : 'color';
  const selected = getItemSelections(picker, item);
  const values = type === 'size' ? selected.sizes : selected.colors;
  const value = type === 'size' ? button.dataset.sizeValue || '' : button.dataset.colorValue || '';
  const index = Math.max(0, Number.parseInt(row.dataset.unitIndex || '1', 10) - 1);
  values[index] = value;

  const key = pickerKey(picker);
  selections.get(key)?.set(item.dataset.quantityValue || '', selected);

  // Atualiza o destaque antes de qualquer troca de variante ou requisição do tema.
  renderPicker(picker);

  // A primeira unidade controla a variante real; as demais são salvas como propriedades do kit.
  if (index === 0) {
    const sourceSelector = type === 'size' ? '[data-bundle-source-size]' : '[data-bundle-source-color]';
    const sourceInput = Array.from(picker.querySelectorAll(sourceSelector)).find((input) => input.value === value);
    if (sourceInput && !sourceInput.checked) {
      sourceInput.checked = true;
      sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

}, true);

document.addEventListener('change', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  const picker = target?.closest(PICKER_SELECTOR);
  if (!picker || !target.closest('[data-quantity-card-option]')) return;
  requestAnimationFrame(() => renderPicker(picker));
});

document.addEventListener('variant:update', (event) => {
  const picker = event.target.closest?.(PICKER_SELECTOR) || event.target.querySelector?.(PICKER_SELECTOR);
  requestAnimationFrame(() => {
    if (picker?.isConnected) renderPicker(picker);
    else renderAll();
  });
});

document.addEventListener('shopify:section:load', renderAll);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderAll, { once: true });
} else {
  renderAll();
}
